export default class LegacyStorage {
  constructor (endpointUri) {
    this.onclose = () => {
    }

    this.uri = endpointUri
    this.username = null
    this.password = null

    this.cache = {}
    this.models = [
      {name: 'people'},
      {name: 'relationships'},
      {name: 'positions'},
      {name: 'locations'},
      {name: 'organisations'},
      {name: 'logentries'},
      {name: 'educations'},
      {name: 'settings', volatile: true}
    ]
  }

  getAuthorizationValue (password) {
    if (this.username && password) {
      return 'Basic ' + btoa(this.username + ':' + password)
    }

    if (this.username && this.password) {
      return 'Basic ' + btoa(this.username + ':' + this.password)
    }

    return ''
  }

  open (username, password) {
    if (username && password) {
      this.setCredentials(username, password)
    }

    return new Promise((resolve) => {
      let modelCount = 0
      this.models.forEach((model) => {
        this.cache[model.name] = {}

        this.getUncached(model).then((modelData) => {
          window.PRIM.setMessage("Ophalen gegevens '" + model.name + "' (" + (modelCount + 1) + ' van ' + this.models.length + ')...')

          modelData.forEach((modelItem) => {
            this.cache[model.name][modelItem.id] = modelItem
          })

          modelCount++

          if (modelCount === this.models.length) {
            resolve()
          }
        })
      })
    })
  }

  close () {
    this.onclose()
  }

  setCredentials (newUsername, newPassword) {
    if (newUsername) {
      this.username = newUsername
    }

    this.password = newPassword
  }

  status (password) {
    return new Promise((resolve, reject) => {
      let request = new XMLHttpRequest()

      request.onreadystatechange = () => {
        if (request.readyState === 4) {
          if (request.status === 200) {
            let contentType = request.getResponseHeader('Content-Type')
            if (contentType === 'application/json') {
              resolve(JSON.parse(request.responseText))
            } else {
              resolve('invalid')
            }
          } else if (request.status === 403) {
            resolve('invalid')
          } else if (request.status === 404) {
            let contentType = request.getResponseHeader('Content-Type')
            if (contentType === 'application/json') {
              resolve('invalid')
            } else {
              reject('offline')
            }
          } else {
            reject('offline')
          }
        }
      }

      let fullUri = this.uri + '/status'
      request.onerror = reject
      request.open('GET', fullUri, true)
      request.setRequestHeader('Authorization', this.getAuthorizationValue(password))
      request.send()
    })
  }

  get (model, id) {
    return new Promise((resolve, reject) => {
      if (model.uncached) {
        return this.getUncached(model, id)
      }

      if (this.cache[model.name]) {
        if (id && this.cache[model.name][id]) {
          resolve(this.cache[model.name][id])
        } else {
          let values = []

          for (let key in this.cache[model.name]) {
            values.push(this.cache[model.name][key])
          }

          resolve(values)
        }
      } else {
        reject()
      }
    })
  }

  getIndexes (model) {
    return new Promise((resolve, reject) => {
      if (this.cache[model.name]) {
        let indexes = {}
        let values = []

        for (let id in this.cache[model.name]) {
          let value = this.cache[model.name][id][key]
          
          if (value && values.indexOf(value) === -1) {
            values.push(value)
          }
        }

        values.sort()

        resolve(values)
      } else {
        reject()
      }
    })
  }

  changePassword (password) {
    return new Promise((resolve, reject) => {
      let request = new XMLHttpRequest()

      request.onreadystatechange = () => {
        if (request.readyState === 4) {
          if (request.status === 200) {
            resolve()
          } else {
            reject()
          }
        }
      }

      let fullUri = this.uri + '/password'

      request.onerror = reject
      request.open('POST', fullUri, true)
      request.setRequestHeader('Authorization', this.getAuthorizationValue())
      request.setRequestHeader('Content-Type', 'application/json')
      request.send(JSON.stringify({ password: password }))
    })
  }

  getUncached (model, id) {
    return new Promise((resolve, reject) => {
      if (model.volatile) {
        if (id) {
          resolve({})
        } else {
          resolve([])
        }
        return
      }

      let request = new XMLHttpRequest()

      request.onreadystatechange = () => {
        if (request.readyState === 4) {
          if (request.status === 200) {
            let data = JSON.parse(request.responseText)

            resolve(data)
          } else {
            reject()
          }
        }
      }

      let fullUri = this.uri + '/' + model.name + '/'

      if (id) {
        fullUri += id
      }

      request.onerror = reject
      request.open('GET', fullUri, true)
      request.setRequestHeader('Authorization', this.getAuthorizationValue())
      request.send()
    })
  }

  put (model, data) {
    window.PRIM.writeStatus()

    return new Promise((resolve, reject) => {
      if (window.PRIM.License.isDemo) {
        window.PRIM.clearStatus()

        let newData = data
        
        if (!newData.id) {
          newData.id = window.PRIM.getUUID()
        }
        
        this.cache[model.name][newData.id] = newData
        resolve(newData)
        return
      }

      let request = new XMLHttpRequest()

      request.onreadystatechange = () => {
        if (request.readyState === 4) {
          if (request.status === 200) {
            window.PRIM.clearStatus()

            let newData = JSON.parse(request.responseText)

            this.cache[model.name][newData.id] = newData
            resolve(newData)
          } else {
            window.PRIM.writeFailedStatus()

            reject()
          }
        }
      }

      let fullUri = this.uri + '/' + model.name

      if (data.id) {
        fullUri += '/' + data.id
      } else {
        delete data.id
      }

      request.onerror = reject
      request.open(data.id ? 'PUT' : 'POST', fullUri, true)
      request.setRequestHeader('Authorization', this.getAuthorizationValue())
      request.setRequestHeader('Content-Type', 'application/json')
      request.send(JSON.stringify(data))
      data.id = null
    }).catch((e) => {
      window.PRIM.writeFailedStatus()
    })
  }

  delete (model, id) {
    return new Promise((resolve, reject) => {
      if (window.PRIM.License.isDemo) {
        if (this.cache[model.name] && this.cache[model.name][id]) {
          delete this.cache[model.name][id]
        }
            
        resolve()
        return
      }

      let request = new XMLHttpRequest()

      request.onreadystatechange = () => {
        if (request.readyState === 4) {
          if (request.status === 200) {
            if (this.cache[model.name] && this.cache[model.name][id]) {
              delete this.cache[model.name][id]
            }
            resolve()
          } else {
            reject()
          }
        }
      }

      let fullUri = this.uri + '/' + model.name + '/' + id
      request.onerror = reject
      request.open('DELETE', fullUri, true)
      request.setRequestHeader('Authorization', this.getAuthorizationValue())
      request.send()
    })
  }

  checkInternet () {
    return new Promise((resolve, reject) => {
      let request = new XMLHttpRequest()

      request.onreadystatechange = () => {
        if (request.readyState === 4) {
          if (request.status === 200) {
            resolve('exists')
          } else if (request.status === 401) {
            resolve('invalid')
          } else if (request.status === 404) {
            resolve('new')
          } else {
            reject('offline')
          }
        }
      }

      request.onerror = reject
      request.open('HEAD', this.uri, true)
      request.setRequestHeader('Authorization', this.getAuthorizationValue())
      request.send()
    })
  }
}



// WEBPACK FOOTER //
// ./js/lib/storage/LegacyStorage.js